import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "input-group" }
const _hoisted_2 = ["value"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text bg-transparent px-2" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search dialog-close text-secondary font-size-sm" })
  ])
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_focus = _resolveDirective("focus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "text",
      class: "form-control border-end-0",
      placeholder: "Search Contact",
      value: _ctx.searchStore.searchTerm,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.update(($event.target as HTMLInputElement).value)))
    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_2), [
      [_directive_focus]
    ]),
    _hoisted_3
  ]))
}